
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Corporatecabservicesinpune() {



    const cardData =
    {
        keyword: 'Corporate Cab Service in Pune ',
        heading: 'Morya Cabs: Corporate Cab Service in Pune ',
        headingDescription: 'If you are looking for a professional and reliable corporate cab service in Pune, Morya Cabs is the perfect solution. Whether it is for business meetings, corporate events, airport transfers, or employee transportation, we offer tailored cab services to meet the needs of your organization. Our fleet of well-maintained vehicles and experienced drivers ensure that your corporate travel is efficient, comfortable, and punctual. Choose Morya Cabs for an impeccable corporate travel experience in Pune.',

        top: 'Corporate Destinations to Visit with Morya Cabs',

   "topPlaces": [
    {
        "title": "Business Districts",
        "description": "Pune's key business areas like Hinjewadi, Magarpatta, and Kharadi are easily accessible with Morya Cabs. Enjoy stress-free rides to these major corporate hubs."
    },
    {
        "title": "Pune International Airport",
        "description": "For corporate travelers, we offer reliable airport transfers, ensuring that your flights are never missed and you travel comfortably to and from Pune Airport."
    },
    {
        "title": "Tech Parks and IT Hubs",
        "description": "Pune is known for its thriving IT sector. Whether it’s a trip to Rajiv Gandhi Infotech Park or other tech parks in the city, Morya Cabs provides seamless travel."
    },
    {
        "title": "Corporate Event Venues",
        "description": "Pune hosts numerous corporate events throughout the year. Whether it's a conference, seminar, or exhibition, we ensure you reach the venue in comfort and style."
    },
    {
        "title": "Luxury Hotels and Resorts",
        "description": "We also provide transportation to luxury hotels and resorts for business stays, ensuring a comfortable and productive visit for corporate executives."
    },
    {
        "title": "Co-Working Spaces",
        "description": "Pune is home to various co-working spaces, and our corporate cab service can transport you to these collaborative environments for your business needs."
    },
    {
        "title": "Meeting and Conference Locations",
        "description": "Whether it's an important client meeting or a team conference, we ensure you arrive on time and in comfort for your business engagements."
    }
],



"services": [
    {
      "name": "Pune Corporate Cab Services",
      "description": "Morya Cab offers professional Pune Corporate Cab Services designed to meet the travel needs of businesses and professionals. Whether it's for a client meeting, corporate event, or daily employee transportation, we provide safe and comfortable rides tailored to your business requirements."
    },
    {
      "name": "Pune Corporate Taxi Booking",
      "description": "Easily book a Pune Corporate Taxi with us for quick, hassle-free travel across the city. With our fast booking system, you can reserve a taxi for any corporate trip, ensuring that you arrive at your destination on time, every time."
    },
    {
      "name": "Pune Corporate Car Rental",
      "description": "Our Pune Corporate Car Rental services offer flexible and customized options for businesses. Whether you need a car for a one-time trip or long-term rentals, we provide well-maintained vehicles for your corporate transportation needs."
    },
    {
      "name": "Pune Corporate Transportation Services",
      "description": "Morya Cab provides comprehensive Pune Corporate Transportation Services, ensuring that your employees, clients, and guests travel in comfort and style. From airport transfers to daily commutes, we have a fleet of vehicles that can be tailored to your specific needs."
    },
    {
      "name": "Pune Corporate Car Hire",
      "description": "Our Pune Corporate Car Hire service allows businesses to book cars for executives, staff, or clients. We provide various vehicle types, including luxury cars, SUVs, and sedans, to ensure that every corporate ride is comfortable and professional."
    },
    {
      "name": "Pune Corporate Taxi Rates",
      "description": "We offer competitive Pune Corporate Taxi Rates that suit your budget without compromising on the quality of service. Whether you require single-day rentals or long-term services, our pricing plans are designed to meet corporate travel demands."
    },
    {
      "name": "Pune Corporate Vehicle Rental",
      "description": "Morya Cab provides a wide range of Pune Corporate Vehicle Rental options to fit your business needs. From sedans to luxury cars and buses, we have the perfect vehicle for corporate transportation in Pune."
    },
    {
      "name": "Pune Corporate Taxi Packages",
      "description": "For regular corporate transportation needs, Morya Cab offers Pune Corporate Taxi Packages. These tailored packages provide you with consistent, reliable taxi service for ongoing business trips, client visits, and meetings."
    },
    {
      "name": "Pune Corporate Transport Solutions",
      "description": "We provide flexible Pune Corporate Transport Solutions that are designed to streamline business travel logistics. Whether it’s employee commuting, client pick-ups, or event transport, we handle all your corporate transport requirements with precision and professionalism."
    },
    {
      "name": "Pune Monthly Service Cabs",
      "description": "If you need a regular, reliable transport solution, our Pune Monthly Service Cabs are perfect for businesses. We offer flexible monthly packages for employees, clients, and business trips, providing a cost-effective way to manage corporate travel."
    },
    {
      "name": "Pune Monthly Cab Services",
      "description": "With Pune Monthly Cab Services, you can easily manage your company's transportation requirements. Book taxis on a monthly basis for consistent service and savings, ensuring smooth operations without worrying about logistics."
    },
    {
      "name": "Pune Monthly Taxi Hire",
      "description": "Our Pune Monthly Taxi Hire options allow you to hire cabs for long-term business use. We offer well-maintained vehicles with experienced drivers, making your corporate transport both reliable and hassle-free."
    },
    {
      "name": "Pune Monthly Car Rental",
      "description": "Opt for Pune Monthly Car Rental if you need a car for regular business use. Morya Cab provides competitive pricing for monthly car rentals, whether you need a sedan, SUV, or luxury vehicle for corporate travel."
    },
    {
      "name": "Pune Monthly Cab Booking",
      "description": "For businesses requiring frequent transportation, we offer Pune Monthly Cab Booking options, so you can reserve rides for your team or clients without worrying about daily arrangements. Our reliable service ensures a smooth experience."
    },
    {
      "name": "Pune Monthly Taxi Packages",
      "description": "Our Pune Monthly Taxi Packages offer businesses an affordable, all-in-one transportation solution for daily, weekly, or monthly corporate travel. These packages provide scheduled trips for regular business use at discounted rates."
    },
    {
      "name": "Pune Monthly Car Lease",
      "description": "For long-term business travel, we offer Pune Monthly Car Lease services. Choose a vehicle on a lease basis for a fixed period and enjoy hassle-free corporate transportation without the burden of ownership."
    },
    {
      "name": "Pune Monthly Cab Rates",
      "description": "We offer Pune Monthly Cab Rates that are competitive and tailored to corporate clients. These rates offer flexibility and savings, ensuring you get the best value for your ongoing transportation needs."
    },
    {
      "name": "Pune Monthly Taxi Costs",
      "description": "With our Pune Monthly Taxi Costs, you can get a transparent and affordable pricing structure for your corporate travel needs. Our monthly taxi packages help businesses plan transportation expenses efficiently."
    },
    {
      "name": "Pune Long-Term Cab Rentals",
      "description": "Looking for Pune Long-Term Cab Rentals? Morya Cab offers affordable long-term rentals for businesses that require vehicles for extended periods. We provide customized packages based on your specific needs."
    }
  ],



  tableData: [
    ["Pune Corporate Cab Services", "-Pune Corporate Taxi Booking"],
    ["Pune Corporate Car Rental", "-Pune Corporate Transportation Services"],
    ["Pune Corporate Car Hire", "-Pune Corporate Taxi Rates"],
    ["Pune Corporate Vehicle Rental", "-Pune Corporate Taxi Packages"],
    ["Pune Corporate Transport Solutions", "-Pune Monthly Service Cabs"],
    ["Pune Monthly Cab Services", "-Pune Monthly Taxi Hire"],
    ["Pune Monthly Car Rental", "-Pune Monthly Cab Booking"],
    ["Pune Monthly Taxi Packages", "-Pune Monthly Car Lease"],
    ["Pune Monthly Cab Rates", "-Pune Monthly Taxi Costs"],
    ["Pune Long-Term Cab Rentals", "-Corporate cab service in Pune contact number"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "Morya Cab ensures your employees, clients, or business partners always reach their destination on time. Whether it’s for a corporate meeting, airport transfer, or event, we value punctuality and ensure a smooth and hassle-free ride for all your corporate transportation needs."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a range of vehicles including sedans, SUVs, and luxury cars. Each vehicle is well-maintained, spacious, and equipped with air conditioning, ensuring a comfortable journey for your employees or guests throughout their time with us."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced professionals trained to provide a smooth and safe ride while maintaining a high level of courtesy and professionalism. They are well-versed in navigating the city and can ensure a timely and efficient journey for all corporate trips."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive pricing for corporate clients, ensuring no hidden charges or surprise fees. We provide an upfront breakdown of costs, so you know exactly what to expect for each ride or bulk service."
    },
    {
        "WhyChooseheading": "Safety and Security",
        "WhyChoosedescription": "We prioritize the safety of your employees, clients, and partners. All vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking to ensure a secure travel experience. Additionally, we adhere to all necessary hygiene protocols to ensure a safe ride during these times."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Morya Cab is available 24/7 to serve your corporate needs. Whether it’s early morning airport pickups or late-night drop-offs after a business event, our services are always available to accommodate your schedule."
    },
    {
        "WhyChooseheading": "Corporate Account Management",
        "WhyChoosedescription": "For businesses that require regular transportation, we offer corporate account services. This allows you to manage bookings, billing, and expenses seamlessly, making it easier for your business to manage transportation logistics."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a corporate cab with Morya Cab is easy and straightforward. You can make reservations through our website, mobile app, or by contacting our customer service team, which will provide you with personalized assistance for all your corporate travel needs."
    }
]






        








    }

    const faqData = [
        {
          question: "How can I book a corporate cab with Morya Cab?",
          answer: "You can book a cab through our website, mobile app, or contact our customer service team for assistance with corporate bookings and to arrange transportation for your employees or clients."
        },
        {
          question: "Are the drivers experienced and professional?",
          answer: "Yes, all of our drivers are highly trained and professional, ensuring a comfortable and safe journey for corporate clients."
        },
        {
          question: "What types of vehicles are available for corporate travel?",
          answer: "We offer a variety of vehicles, including sedans, SUVs, and premium cars, to cater to different group sizes and preferences. All our vehicles are well-maintained and equipped with modern amenities."
        },
        {
          question: "How do I pay for corporate cab services?",
          answer: "We offer flexible payment options, including cash, credit/debit cards, and online payments through our app or corporate accounts for seamless billing and invoicing."
        },
        {
          question: "Can I book a round trip for corporate travel?",
          answer: "Yes, you can book round trips or multiple transfers for your corporate trips. Just provide us with the details, and we will arrange everything accordingly."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any extra charges, such as waiting time or detours, will be communicated to you upfront to ensure complete transparency in pricing."
        },
        {
          question: "Can I hire a corporate cab for airport transfers?",
          answer: "Yes, we offer airport transfer services for your employees or clients, ensuring a timely and comfortable ride to and from Pune’s airport."
        },
        {
          question: "Do you offer corporate discounts or packages?",
          answer: "Yes, we offer corporate discounts and customized packages for businesses that require regular transportation services. Please contact us to learn more about corporate plans and pricing."
        },
        {
          question: "What is the booking process for regular corporate travel?",
          answer: "We provide an easy booking process, and you can set up a corporate account to handle recurring bookings, making it more convenient for your business."
        },
        {
          question: "Why should I choose Morya Cab for corporate travel in Pune?",
          answer: "Morya Cab offers reliable, safe, and affordable corporate travel solutions with professional drivers, comfortable vehicles, and transparent pricing. We strive to make your corporate transportation experience efficient and stress-free."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Vijay Deshmukh',
          role: 'Business Owner',
          review: "We’ve been using Morya Cab for our company’s transportation needs, and we are extremely satisfied. Their drivers are always professional and punctual, and the vehicles are in top condition. It makes corporate travel easy and stress-free.",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Ms. Shweta Reddy',
          role: 'Corporate Executive',
          review: "Morya Cab has been a great partner for our business travel. We rely on them for airport transfers and client pick-ups. Their service is consistent, and their team is always willing to accommodate our requests.",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];
    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "TaxiService",
        "name": "Corporate Cab Service in Pune",
        "description": "Offering corporate taxi services in Pune, including car rentals, long-term leases, monthly bookings, and more for businesses. Affordable rates and dependable transportation solutions for corporate needs.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Office No. 5, Business Hub, ABC Road",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411028",
          "addressCountry": "IN"
        },
        "telephone": "+91-8888888888",
        "url": "https://moryacab.com/corporate-cab-services-pune",
        "logo": "https://moryacab.com/img/corporate-taxi-logo.jpg",
        "image": [
          "https://moryacab.com/img/corporate-taxi-services.jpg",
          "https://moryacab.com/img/monthly-cab-service.jpg"
        ],
        "priceRange": "₹15,000 - ₹50,000 per month",
        "offers": {
          "@type": "Offer",
          "url": "https://moryacab.com/corporate-cab-services-pune",
          "priceCurrency": "INR",
          "price": 2000,
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": 4.8,
          "reviewCount": 100
        },
        "serviceArea": {
          "@type": "Place",
          "name": "Pune",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 18.5204,
            "longitude": 73.8567
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://moryacab.com/corporate-cab-services-pune"
        },
        "keywords": "Pune Corporate Cab Services, Pune Corporate Taxi Booking, Pune Corporate Car Rental, Pune Corporate Transportation Services, Pune Corporate Car Hire, Pune Corporate Taxi Rates, Pune Corporate Vehicle Rental, Pune Corporate Taxi Packages, Pune Corporate Transport Solutions, Pune Monthly Service Cabs, Pune Monthly Cab Services, Pune Monthly Taxi Hire, Pune Monthly Car Rental, Pune Monthly Cab Booking, Pune Monthly Taxi Packages, Pune Monthly Car Lease, Pune Monthly Cab Rates, Pune Monthly Taxi Costs, Pune Long-Term Cab Rentals, Corporate Cab Service in Pune Contact Number"
      };
      

   


    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Corporate Cab Service in Pune | Monthly Taxi Rental & Corporate Car Hire | Call: +91 9371304510</title>
  <meta
    name="description"
    content="Corporate cab services in Pune for businesses. Monthly cab bookings, car rental, corporate taxi hire, long-term cab rental, and transport solutions at affordable rates."
  />
  <meta
    name="keywords"
    content="Pune Corporate Cab Services, Pune Corporate Taxi Booking, Pune Corporate Car Rental, Pune Corporate Transportation Services, Pune Corporate Car Hire, Pune Corporate Taxi Rates, Pune Corporate Vehicle Rental, Pune Corporate Taxi Packages, Pune Corporate Transport Solutions, Pune Monthly Service Cabs, Pune Monthly Cab Services, Pune Monthly Taxi Hire, Pune Monthly Car Rental, Pune Monthly Cab Booking, Pune Monthly Taxi Packages, Pune Monthly Car Lease, Pune Monthly Cab Rates, Pune Monthly Taxi Costs, Pune Long-Term Cab Rentals, Corporate Cab Service in Pune Contact Number"
  />
  <meta property="og:title" content="Corporate Cab Service in Pune | Monthly Taxi Rental & Corporate Car Hire" />
  <meta
    property="og:description"
    content="Reliable corporate cab services in Pune for businesses, including long-term rentals, monthly packages, and transport solutions to fit corporate needs."
  />
  <meta property="og:url" content="https://moryacab.com/corporate-cab-services-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://moryacab.com/img/corporate-taxi-services.jpg" />
  <script type="application/ld+json">
    {JSON.stringify(jsonLD)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/63.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Corporatecabservicesinpune;